jQuery(document).ready(function ($) {
   $('.product-form [data-js-product-add-to-cart]').on('click', function() {
    if($('.upsell-product').length > 0) {
      let items = [];
      $('.upsell-checkbox:checked').each(function () {
        let variantId = $(this).data('variant-id');
        if (variantId) {
          items.push({
            id: parseInt(variantId),
            quantity: 1
          });
        }
      });

      console.log(items);
  
      if (items.length > 0) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: items })
        })
        .then(response => response.json())
        .then(data => {
          console.log('All items added to cart:', data);
        })
        .catch(error => {
          console.error('Error adding items to cart:', error);
        });
      }
    }
  });
    
});

//-------------13 march --------------------

jQuery(document).ready(function ($) {
  // // Run script ONLY on multistep bundle template
  // if (!$('body').hasClass('template-product-multistep-bundle')) {
  //   return;
  // }

  // Run this controller where the multistep bundle markup is present, including AB-test template copies.
  if (!$('.product-layout-multistep .bundle_product__type_step').length ||
      !$('.product-layout-multistep .multistep-upsell-outer').length) {
    return;
  }

  let pendingBundleUpsellItems = [];

  function getSelectedTab() {
    let selectedPurchaseType = $('input[name="purchase_type"]:checked').val();
    let selectedTab = $('.bundle_order__type-form').attr('selected_tab');

    if (selectedPurchaseType === "onetime") {
      selectedTab = "rc_purchase_type_onetime_tab";
    }

    if (selectedPurchaseType === "autodeliver") {
      selectedTab = "rc_purchase_type_autodeliver_tab";
    }

    if (selectedTab) {
      $('.bundle_order__type-form').attr('selected_tab', selectedTab);
    }

    return selectedTab;
  }

  function getSelectedUpsellItems() {
    let items = [];

    $('.multistep-upsell-outer .upsell-checkbox:checked').each(function () {
      let variantId = $(this).data('variant-id');

      console.log("Checked upsell variant:", variantId);

      if (variantId) {
        items.push({
          id: parseInt(variantId),
          quantity: 1
        });
      }
    });

    return items;
  }

  function addUpsellItemsToCart(items) {
    if (!Array.isArray(items) || !items.length) return Promise.resolve();

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
    .then(res => {
      return res.json().catch(() => ({})).then(data => {
        if (!res.ok) {
          throw new Error(data.description || data.message || 'Error adding upsell items');
        }

        return data;
      });
    })
    .then(data => {
      refreshCart();
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: {
          source: 'bundle-upsell-add-to-cart',
          cartAddResponse: data
        }
      }));
      console.log("Upsell items successfully added:", data);
      return data;
    })
    .catch(err => {
      console.error("Error adding upsell items:", err);
    });
  }

  function checkUpsellVisibility() {

    let upsellType = $('.bundle_multistep__step.bundle_product__type_step').attr('data-show-upsell');
    let selectedTab = getSelectedTab();

    console.log("Upsell Type:", upsellType);
    console.log("Selected Tab:", selectedTab);

    let showUpsell = false;

    if (upsellType === "Subscription" && selectedTab === "rc_purchase_type_autodeliver_tab") {
      console.log("Condition matched: Subscription + Autodeliver tab");
      showUpsell = true;
    }

    else if (upsellType === "onetime" && selectedTab === "rc_purchase_type_onetime_tab") {
      console.log("Condition matched: One-time purchase");
      showUpsell = true;
    }

    else if (
      upsellType === "Both" &&
      (selectedTab === "rc_purchase_type_onetime_tab" ||
       selectedTab === "rc_purchase_type_autodeliver_tab")
    ) {
      console.log("Condition matched: Both purchase types allowed");
      showUpsell = true;
    }

    else {
      console.log("No condition matched → Upsell hidden");
    }

    if (showUpsell) {
      console.log("Showing multistep upsell");
      $('.multistep-upsell-outer').show();
    } else {
      console.log("Hiding multistep upsell");
      $('.multistep-upsell-outer').hide();
    }

    return showUpsell;
  }

  // Page load
  console.log("Page loaded → Checking upsell visibility");
  checkUpsellVisibility();


  // Purchase type change
  $('input[name="purchase_type"]').on('change', function () {

    console.log("Purchase type changed:", $(this).val());

    if ($(this).val() === "onetime") {
      console.log("Switching to One-time tab");
      $('.bundle_order__type-form').attr('selected_tab','rc_purchase_type_onetime_tab');
    }

    if ($(this).val() === "autodeliver") {
      console.log("Switching to Subscription tab");
      $('.bundle_order__type-form').attr('selected_tab','rc_purchase_type_autodeliver_tab');
    }

    checkUpsellVisibility();
  });


  // Add to cart click
  $('.bundle-add-to-cart').on('click', function () {

    console.log("Add to cart clicked");

    if (!checkUpsellVisibility()) {
      console.log("Upsell not allowed → Skipping upsell add to cart");
      return;
    }

    let items = getSelectedUpsellItems();

    console.log("Upsell items to add:", items);

    if (items.length > 0) {
      pendingBundleUpsellItems = items;
      console.log("Queued upsell items until bundle add succeeds:", pendingBundleUpsellItems);

    } else {
      console.log("No upsell items selected");
    }

  });

  document.addEventListener('ys:bundle-add:success', function () {
    let items = pendingBundleUpsellItems;
    pendingBundleUpsellItems = [];
    addUpsellItemsToCart(items);
  });

  document.addEventListener('ys:bundle-add:error', function () {
    pendingBundleUpsellItems = [];
  });

});





// jQuery(document).ready(function ($) {
//    $('.product-form [data-js-product-add-to-cart]').on('click', function() {
//     if($('.upsell-product').length > 0) {
//       let items = [];
//       $('.upsell-checkbox:checked').each(function () {
//         let variantId = $(this).data('variant-id');
//         if (variantId) {
//           items.push({
//             id: parseInt(variantId),
//             quantity: 1
//           });
//         }
//       });

//       console.log(items);
  
//       if (items.length > 0) {
//         fetch('/cart/add.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             'Accept': 'application/json'
//           },
//           body: JSON.stringify({ items: items })
//         })
//         .then(response => response.json())
//         .then(data => {
//           console.log('All items added to cart:', data);
//         })
//         .catch(error => {
//           console.error('Error adding items to cart:', error);
//         });
//       }
//     }
//   });
    
// });
